import AsyncComponent from '../../routes/AsyncComponent'

export const LazyHomeLayout = AsyncComponent(
  () => import(/* webpackChunkName: 'home-layout' */ './HomeLayout')
)
